/*
 *
 * Package: `@dbh/with-conforms-to-for-production-www`.
 * Do not import anything in this package.
 */const withConformsToForProductionWWW=(a,b,c)=>function(){return c(...arguments)};

export { withConformsToForProductionWWW as default };
